import { DomainScopes } from "../../constants/DomainConstants";

const tabTypes = [
    {
        typeId: 121450000,
        title: "type1",
        tabNumber: 0
    },
    {
        typeId: 121450001,
        title: "type2",
        tabNumber: 1
    },
    {
        typeId: 121450002,
        title: "type3",
        tabNumber: 2
    }
];

export function GetTopNavItems(topNavTabSettings, accountId, scope) {
    let items;
    switch (scope) {
        case DomainScopes.DEFAULT:
            items = getTopNavItems(topNavTabSettings, accountId);
            break;
        default:
            items = getTopNavItems(topNavTabSettings, accountId);
            break;
    }

    return items;
}

function getTopNavItems(topNavTabSettings, accountId) {
    return Object.keys(topNavTabSettings).map(key => {
        const tabSettings = topNavTabSettings[key];
        return {
            text: tabSettings.text,
            to: "/" + accountId + tabSettings.urlSuffix, //scope/:accountId/tab/:sportkampId
            iconType: tabSettings.iconType,
            color: tabSettings.color,
            disabled: tabSettings.disabled,
            visible: tabSettings.visible,
            hideText: true
        };
    });
}

export function formatValidatieStatussesForBeads(validatieStatusses) {
    return validatieStatusses.map(v => {
        const tabType = tabTypes.find(x => x.typeId == v.entiteitType);
        return {
            tab: tabType ? tabType.tabNumber : null,
            volledig: v.volledig,
            title: v.titel || (tabType ? tabType.title : null)
        };
    });
}

export function formatValidatieStatussesForSideNav(validatieStatusses) {
    const sideNavValidatieStatusses = validatieStatusses.filter(v => v.entiteitType == tabTypes[2].typeId).sort(v => v.titel);
    return sideNavValidatieStatusses.map(v => {
        return {
            url: "/sidenaventity/" + v.tochtGuid + "/" + v.entiteitGuid,
            display: v.titel,
            linkEnabled: true,
            lusId: v.entiteitGuid
        };
    });
}